import React, { useCallback } from 'react';
import { Container, Card, CardBody, Button, Spinner } from 'reactstrap';
import AdvisorsList from './components/advisors-list';
import { Link, useHistory } from 'react-router-dom';
import useGet from '../../helpers/hooks/useGet';
const Advisors = (props) => {
  const history = useHistory();
  const [advisors, , advisorsLoading] = useGet('/advisories', true);
  const handleEditAdvisor = useCallback(
    (obj) => {
      history.push(`/users/edit-advisor/${obj.id}`);
    },
    [history]
  );
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <div className='align-items-end d-flex justify-content-between mb-3'>
            <h4>Advisors</h4>
            <Link to='/users/add-new-advisor'>
              <Button
                color='primary'
                outline
                type='button'
                size='sm'
                className='waves-effect waves-light'
              >
                Add New Advisor{' '}
                <i className='mdi mdi-plus align-middle ml-2'></i>
              </Button>
            </Link>
          </div>
          <Card>
            <CardBody>
              {advisorsLoading ? (
                <div className='text-center'>
                  <Spinner className='mr-2' color='primary' />
                </div>
              ) : (
                <AdvisorsList
                  advisors={advisors}
                  editAdvisor={handleEditAdvisor}
                ></AdvisorsList>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default Advisors;
